import React from 'react'

const DietPlanQuestionnaireDetails = () => {
  return (
    <div>DietPlanQuestionnaireDetails</div>
  )
}

export default DietPlanQuestionnaireDetails